export const CareerData = [
  {
    text: "Junior Unity Developer",
    descL:
      "Looking for a fresh graduate with passion for game development, strong OOP and data structure concepts required.",
    btn: "Apply Now",
  },
  {
    text: "Post Production CG Artist",
    descL:
      "Looking for 2-3 years experienced CG Artist for post-production work on game screenshots and icons.",
    btn: "Apply Now",
  },
  {
    text: "Concept Artist",
    descL:
      "Looking for 2-3 years experienced character and environment artist for creating sketches and storyboarding.",
    btn: "Apply Now",
  },
  {
    text: "3D Modeler",
    descL:
      "Looking for 3-4 years experienced character and environment modeler with expertise in Blender and Maya.",
    btn: "Apply Now",
  },
  {
    text: "3D Animator",
    descL:
      "Looking for 3-4 years experienced character animator who has worked in gaming industry and can bring characters to life.",
    btn: "Apply Now",
  },
  {
    text: "Art Director",
    descL:
      "Looking for 6-8 years experienced Art Director to  guide the art style of the game. Strong academic background with hands-on work is must.",
    btn: "Apply Now",
  },

  {
    text: "HR Officer",
    descL:
      "Looking for fresh MBA/BBA HR graduate, with strong communication skills and pleasant personality, able to multitask effectively.",
    btn: "Apply Now",
  },
];
